import React from "react";
import firebase from "firebase";
import axios from "axios";

//Fetches the questions and answers to display in a table below double bar graph in statistics
function FetchQuizAssignment(classLevel, assignment){
    let promise = new Promise(resolve => {
        const assignmentFile = firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/quizAssignments/' + assignment);
        assignmentFile.getDownloadURL()
            .then(url => axios.get(url))
            .then(res => {
                resolve(res.data)
            });
    })
    return promise;
}

export default FetchQuizAssignment
